import React, {Fragment} from 'react';
import moment from 'moment';

const MessageItem = ({message, isSender,time,name}) => {
    return (
        <div className="row no-gutters">
            <div className={`msg-box ${isSender && 'ml-auto'}`}>
                <p className={`chat-bubble ${isSender ? 'chat-bubble--right' : 'chat-bubble--left'}`}>
                    {(name && !isSender) &&<Fragment><span className={` ${isSender ?'text-gray':'text-primary'}`}>@{name}</span> <br/></Fragment>}
                    {message}
                    <small className="d-block text-right"><i className="fas fa-check"/> {moment(time).utc().fromNow(true)}</small>
                </p>
            </div>
        </div>
    );
};

export default MessageItem;
